import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.85",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.75 9.55c0 4.9-6.75 10.05-6.75 10.05S5.25 14.45 5.25 9.55a6.75 6.75 0 1 1 13.5 0Z" }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "9.55",
      r: "2.35"
    }, null, -1),
    _createElementVNode("path", { d: "M8.5 21h7" }, null, -1)
  ]))]))
}
export default { render: render }